import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import {
  EmployeeStandardCellView,
  EmployeeStandardMatrixUser,
  EmployeeStandardRowView
} from '../../../../../../models/employee-standard-overrides.model';

const EMPTY_CHANGE_COUNT = 0;

@Component({
  selector: 'app-employee-standard-matrix',
  templateUrl: './employee-standard-matrix.component.html',
  styleUrls: ['./employee-standard-matrix.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EmployeeStandardMatrixComponent {
  @Input() public users: EmployeeStandardMatrixUser[] = [];
  @Input() public rows: EmployeeStandardRowView[] = [];
  @Input() public changedCount = 0;
  @Input() public isLoading = false;
  @Input() public isSaving = false;
  @Input() public blocked = false;
  @Output() public readonly cellToggled = new EventEmitter<EmployeeStandardCellView>();
  @Output() public readonly changesSaved = new EventEmitter<void>();
  @Output() public readonly selectionOpened = new EventEmitter<void>();

  public get hasRows(): boolean {
    return this.rows.length > 0;
  }

  public get canSave(): boolean {
    return !this.blocked && !this.isSaving && !this.isLoading && this.changedCount > EMPTY_CHANGE_COUNT;
  }

  public onToggleCell(cell: EmployeeStandardCellView): void {
    if (!cell || cell.isDisabled || this.isSaving || this.isLoading || this.blocked) {
      return;
    }
    this.cellToggled.emit(cell);
  }

  public onSaveChanges(): void {
    if (!this.canSave) {
      return;
    }
    this.changesSaved.emit();
  }

  public onOpenSelection(): void {
    this.selectionOpened.emit();
  }

  public trackByUser(index: number, user: EmployeeStandardMatrixUser): string {
    return user.id;
  }

  public trackByRow(index: number, row: EmployeeStandardRowView): string {
    return row.id;
  }

  public trackByCell(index: number, cell: EmployeeStandardCellView): string {
    return cell.id;
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/views/view-group/popups/employee-standard-overrides/employee-standard-matrix/employee-standard-matrix.component.ts